module.exports = __webpack_public_path__ + "img/commercial-car.8637624.svg";